import Emitter from './Emitter'

export default class {
  constructor (opts = {}) {
    this.connectorUrl = ''
    this.protocol = ''
    this.opts = opts
    if (opts.store) { this.store = opts.store }
    //this.connect(connectionUrl, opts)
    //this.onEvent()
  }

  connect (connectionUrl, opts = {}) {
    opts = opts || this.opts
    let protocol = opts.protocol || ''
    this.connectionUrl = connectionUrl
    this.protocol = protocol
    this.WebSocket = opts.WebSocket || (protocol === '' ? new WebSocket(connectionUrl) : new WebSocket(connectionUrl, protocol))
    this.onEvent()
    return this.WebSocket
  }

  reconnect(){
    if(!this.WebSocket.readyState || this.WebSocket.readyState === 3 ){
      this.WebSocket =  (this.protocol == '' ? new WebSocket(this.connectionUrl):new WebSocket(this.connectionUrl,this.protocol))
      this.onEvent()
    }
  }


  send(obj){
    if(!this.WebSocket){
      throw new Error('the websocket object do not exists connection,please use this.$ws.connec() first') 
    }
    return this.WebSocket.send(JSON.stringify(obj))
  }

  close(){
    if(this.WebSocket){
      this.WebSocket.close()
    }
  }

  sendEvent(event,data){
    return this.send({event:event,data:data})
  }

  onEvent () {
    ['onmessage', 'onclose', 'onerror', 'onopen'].forEach((eventType) => {
      this.WebSocket[eventType] = (event) => {
        Emitter.emit(eventType, event)
        if (this.store) { this.passToStore('SOCKET_' + eventType, event) }
      }
    })
  }

  onUserEvent(event,data){
    Emitter.emit(event,data)
  }

  passToStore (eventName, event) {
    if (!eventName.startsWith('SOCKET_')) { return }
    let method = 'commit'
    let target = eventName.toUpperCase()
    let msg = event
    if (this.format === 'json' && event.data) {
      msg = JSON.parse(event.data)
      if (msg.mutation) {
        target = [msg.namespace || '', msg.mutation].filter((e) => !!e).join('/')
      } else if (msg.action) {
        method = 'dispatch'
        target = msg.action
      }
    }
    this.store[method](target, msg)
  }
}



// WEBPACK FOOTER //
// ./src/libs/websocket/Observer.js